module.exports = __webpack_public_path__ + "img/Bold 2px-profile_circled-white.7d47fa18.svg";